var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteproposal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.769V3L4.38475 4.23075L5.80775 3L7.23075 4.23075L8.65375 3L10.077 4.23075L11.5 3L12.923 4.23075L14.3462 3L15.7692 4.23075L17.1922 3L18.6152 4.23075L20 3V21.769H3ZM5.75 16.8268H10.25V15.3268H5.75V16.8268ZM5.75 13.1345H12.25V11.6345H5.75V13.1345ZM5.75 9.44225H17.25V7.94225H5.75V9.44225ZM4.5 20H18.5V5.2845H4.5V20Z",
    fill: "#A50DFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.0017V16.7957L15.5323 12.2841C15.6361 12.1803 15.7482 12.1072 15.8686 12.0649C15.9889 12.0228 16.1093 12.0017 16.2297 12.0017C16.3609 12.0017 16.4878 12.0262 16.6106 12.0754C16.7333 12.1246 16.8448 12.1985 16.9451 12.297L17.7174 13.0772C17.8073 13.1812 17.8769 13.2936 17.9261 13.4145C17.9754 13.5354 18 13.6563 18 13.7773C18 13.8982 17.9775 14.0212 17.9326 14.1465C17.8876 14.2717 17.8159 14.3862 17.7174 14.49L13.2059 19.0017H11ZM11.9954 18.0063H12.7885L15.4985 15.2832L15.1149 14.8866L14.7263 14.495L11.9954 17.2132V18.0063ZM15.1149 14.8866L14.7263 14.495L15.4985 15.2832L15.1149 14.8866Z",
    fill: "#A50DFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteproposal);
export default __webpack_public_path__ + "static/media/Quoteproposal.a14db25f128166b13381373bb37ae86e.svg";
export { ForwardRef as ReactComponent };